import {
    GET_CASH_PAYMENTS_SUCCESS, 
    GET_PAYMENT_MADE_FROM_LEDGER_LIST_SUCCESS,
    GET_PAYMENT_MADE_TO_LEDGER_LIST_SUCCESS,
    GET_AMOUNT_BY_REF_NO_SUCCESS,
    GET_BILL_REF_NO_SUCCESS,
    GET_LEDGER_LIST_FOR_DOUBLE_ENTRY_SUCCESS,
    CHEK_DUPLICATE_BILL_REF_NO_SUCCESS,
    GET_ITEM_LIST_FOR_INVENTORY_SUCCESS,
    GET_HSN_LIST_FOR_INVENTORY_SUCCESS,
    GET_UNITS_LIST_FOR_INVENTORY_SUCCESS,
    GET_GODOWN_LIST_FOR_INVENTORY_SUCCESS
} from "src/actions/actionTypes";

const initialState = {
   cashPayments: "",
   paymentMadeFromLedgerList: [],
   paymentMadeToLedgerList: [],
   billRefByLedger:[],
   amountByBillRef:[],
   ledgerListForDoubleEntry:[],
   duplocateCount:{},
   inventoryItemsList: [],
   inventoryHsnList: [],
   inventoryUnisList: [],
   inventoryGodownList: []
};

export default function cashPaymentsReducer(state = initialState, action) {
    switch (action.type) {
        case GET_CASH_PAYMENTS_SUCCESS: {
            return { ...state, cashPayments: action.payload };
        }
        case GET_PAYMENT_MADE_FROM_LEDGER_LIST_SUCCESS: {
            return { ...state, paymentMadeFromLedgerList: action.payload}
        }
        case GET_PAYMENT_MADE_TO_LEDGER_LIST_SUCCESS: {
            return { ...state, paymentMadeToLedgerList: action.payload}
        }
        case GET_AMOUNT_BY_REF_NO_SUCCESS: {
            return { ...state, amountByBillRef: action.payload}
        }
        case GET_BILL_REF_NO_SUCCESS: {
            return { ...state, billRefByLedger: action.payload}
        }
        case GET_LEDGER_LIST_FOR_DOUBLE_ENTRY_SUCCESS: {
            return { ...state, ledgerListForDoubleEntry: action.payload}
        }
        case CHEK_DUPLICATE_BILL_REF_NO_SUCCESS: {
            return { ...state, duplocateCount: action.payload}
        }
        case GET_ITEM_LIST_FOR_INVENTORY_SUCCESS: {
            return { ...state, inventoryItemsList: action.payload}
        }
        case GET_HSN_LIST_FOR_INVENTORY_SUCCESS: {
            return { ...state, inventoryHsnList: action.payload}
        }
        case GET_UNITS_LIST_FOR_INVENTORY_SUCCESS: {
            return { ...state, inventoryUnisList: action.payload}
        }
        case GET_GODOWN_LIST_FOR_INVENTORY_SUCCESS: {
            return { ...state, inventoryGodownList: action.payload}
        }
        
        default:
            return state;
    }
}
